import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';

import styles from './LogOut.scss';

const LogOut: React.FC<{}> = ({}) => {
    const { t } = useTranslation();
    useEffect(() => {
        Logger.log(LoggerLevel.UseEffect, { source: LoggerSource.React, component: 'LogOut', message: 'REACT :: VIEW :: LOGOUT' });
    }, []);

    return (
        <div className={styles['logout__container']}>
            <div className={styles['logout__dialog']}>
                <div className={styles['logout__dialog-message']}>
                    <>{t('LOGOUT_LOGOUT_MESSAGE')},</>
                </div>
            </div>
        </div>
    );
};

export default LogOut;
